import { render, staticRenderFns } from "./AddSuppliersForm.vue?vue&type=template&id=c167c78a&scoped=true&"
import script from "./AddSuppliersForm.vue?vue&type=script&lang=js&"
export * from "./AddSuppliersForm.vue?vue&type=script&lang=js&"
import style0 from "./AddSuppliersForm.vue?vue&type=style&index=0&id=c167c78a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c167c78a",
  null
  
)

export default component.exports